import React, { useEffect } from "react";
import reactLogo from "../../Assets/Slider/React.png";
import javascriptLogo from "../../Assets/Slider/Javascript.jpg";
import htmlLogo from "../../Assets/Slider/html.png";
import cssLogo from "../../Assets/Slider/CSS.png";
import firebaseLogo from "../../Assets/Slider/firebase.png";
import bootstrapLogo from "../../Assets/Slider/bootstrap.png";
import materialLogo from "../../Assets/Slider/material-ui.png";
import expressLogo from "../../Assets/Slider/express.png";
import nodeLogo from "../../Assets/Slider/nodejs.png";
import mongoLogo from "../../Assets/Slider/mongodb.png";
import phpLogo from "../../Assets/Slider/php.png";
import sqlLogo from "../../Assets/Slider/sql.png";
import wordpressLogo from "../../Assets/Slider/wordPress.png";
import woocommerce from "../../Assets/Slider/woocommerce.png";

const ImageSlider = () => {
  useEffect(() => {
    const copy = document.querySelector(".logos-slide").cloneNode(true);
    document.querySelector(".logos").appendChild(copy);
  }, []);
  return (
    <React.Fragment>
      <div class="logos">
        <div class="logos-slide">
          <img src={reactLogo} />
          <img src={javascriptLogo} />
          <img src={htmlLogo} />
          <img src={cssLogo} />
          <img src={firebaseLogo} />
          <img src={bootstrapLogo} />
          <img src={materialLogo} />
          <img src={expressLogo} />
          <img src={nodeLogo} />
          <img src={mongoLogo} />
          <img src={phpLogo} />
          <img src={sqlLogo} />
          <img src={wordpressLogo} />
          <img src={woocommerce} />
        </div>
      </div>
    </React.Fragment>
  );
};

export default ImageSlider;
